import * as React from "react"
import { Eye, EyeOff } from "lucide-react"

import { cn } from "@/lib/utils"

import { Input } from "./input"

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {}

const PasswordInput = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, ...props }, ref) => {
    const [showPassword, setShowPassword] = React.useState(false)
    const handleClickShowPassword = () => setShowPassword(prev => !prev)
    return (
      <div
        className={cn(
          "relative overflow-hidden h-10 w-full rounded-md border border-input bg-background text-sm ring-offset-background disabled:cursor-not-allowed disabled:opacity-50 focus-visible:outline-none focus-within:ring-2 focus-within:ring-ring focus-within:ring-offset-2",
          className
        )}
      >
        <Input ref={ref} type={showPassword ? "text" : "password"} {...props} className={cn("border-0 shadow-none focus-visible:ring-0 focus-visible:ring-offset-0", className)} />
        <div
          className="absolute right-3 top-1/2 z-10 -translate-y-1/2 cursor-pointer"
          onClick={handleClickShowPassword}
        >
          {showPassword ? (
            <EyeOff className="text-muted-foreground" />
          ) : (
            <Eye className="text-muted-foreground" />
          )}
        </div>
      </div>
    )
  }
)
PasswordInput.displayName = "PasswordInput"

export { PasswordInput }
